<template>
  <div
    class="dt-input-box--container"
    :class="{
      maximized: maximized,
      minimized: !maximized,
      outlined: outlined,
      [this.controlStyle]: true,
    }"
  >
    <div
      class="dt-input-box"
      @click="onEditClick"
      :class="{
        maximized: maximized,
        minimized: !maximized,
        outlined: outlined,
        invalid: touched && !validationResult.valid,
        textarea: textarea,
        input: !textarea,
        disabled: controlDisabled,
        [this.controlStyle]: true,
      }"
      :style="{
        height: heightComputed,
      }"
    >
      <div
        class="dt-input-box--label"
        style="width: 100%; position: relative"
        :class="{
          label: maximized,
          placeholder: !maximized,
          textarea: textarea,
          input: !textarea,
        }"
      >
        <template>
          <span class="dt-input-box--label-text">{{ placeholder }}</span>
        </template>
        <template v-if="rightIcon != ''">
          <div class="ut-flex" style="position: absolute; right: 0px; top: 0px">
            <!-- <div style="flex:1;font-size:14px">
               {{ placeholder }}
             </div> -->
            <div class="dt-icon-container">
              <img :src="rightIcon" class="dt-icon s2" alt="" />
            </div>
          </div>
        </template>
      </div>
      <div
        class="dt-input-box--edit"
        @click="onEditClick"
        v-if="showEditIconOnHover && !maximized"
      >
        <img src="static/icons/edit.svg" class="dt-icon" alt="" />
      </div>

      <div
        @click="onSearchClick"
        style=""
        v-if="searchIcon != ''"
        class="search-label ut-link ut-text-accent5"
      >
        {{ searchLinkText }}
      </div>
      <div
        class="dt-icon-container"
        @click="onSearchClick"
        v-if="searchIcon != ''"
        style="opacity: 1; min-width: 30px; cursor: pointer; z-index: 1"
      >
        <img
          style="cursor: pointer"
          :src="`static/icons/${searchIcon}.svg`"
          class="dt-icon s0"
          alt=""
        />
      </div>
      <div class="input-container" :class="{ minimized: !maximized }">
        <input
          v-if="!textarea"
          :id="inputId"
          :name="inputId"
          ref="input_element"
          height="5"
          :type="inputType"
          :value="textInputValue"
          :title="textInputValue"
          @blur="onTextInputBlur"
          @focus="onTextInputFocus"
          @keyup="onTextInputKeyup"
          @change="onInputChange"
          :disabled="controlDisabled"
          :readonly="controlReadonly"
          :autocomplete="autocomplete"
          autocorrect="off"
          spellcheck="false"
        />
        <textarea
          v-if="textarea"
          :id="inputId"
          :name="inputId"
          ref="input_element"
          rows="5"
          :type="inputType"
          :value="textInputValue"
          :title="textInputValue"
          @blur="onTextInputBlur"
          @focus="onTextInputFocus"
          @keyup="onTextInputKeyup"
          @change="onInputChange"
          :disabled="controlDisabled"
          :style="{
            height: height - 40 + 'px',
          }"
        >
        </textarea>

        <template v-if="isReadonly && !isReadonlyWrite">
          <div class="input--options">
            <div @click="RO_onStartChange" class="dt-button v2">
              <div class="dt-button--text">Change {{ placeholder }}</div>
            </div>
            <!-- <div class="input--change">
              Change {{placeholder}}
            </div> -->
          </div>
        </template>
      </div>
      <div
        class="validation-status"
        :class="{
          'status-inside': statusInside,
        }"
      >
        <div class="dt-icon-container" v-if="showValidationIcons">
          <img
            v-if="(touched || immediateValidation) && validationResult.valid"
            src="static/icons/textbox-complete.svg"
            class="dt-icon"
            alt=""
          />
          <img
            v-if="(touched || immediateValidation) && !validationResult.valid"
            :title="errorMessages()"
            src="static/icons/textbox-incomplete.svg"
            class="dt-icon"
            alt=""
          />
        </div>
      </div>
      <div
        class="validation-status status-inside"
        
      >
        <div class="dt-icon-container" v-if="loading">
          <img src="static/icons/loading.gif" />
        </div>
      </div>
    </div>
    <v-menu
      v-if="typeahead"
      :close-on-content-click="false"
      :close-on-click="false"
      :value="typeaheadMenu"
      :nudge-right="0"
      transition="slide-y-transition"
      full-width
      offset-y
    >
      <div
        slot="activator"
        @click.stop=""
        class="textbox-dropdown-activator"
      ></div>
      <div class="dropdown--list">
        <template v-if="options.length > 0">
          <div
            @click="(e) => onOptionClicked(option)"
            class="dropdown--item"
            v-for="option of options"
            :key="option.value"
          >
            <div class="dropdown--item--text">
              {{ option.text }}
            </div>
          </div>
        </template>
        <template v-if="options.length == 0 && touched">
          <div class="dropdown--item">No Items</div>
        </template>
      </div>
    </v-menu>
    <v-menu
      v-if="isPickerType"
      :close-on-content-click="false"
      :close-on-click="false"
      :value="pickerMenu"
      :nudge-right="50"
      transition="slide-y-transition"
      full-width
      offset-y
    >
      <div
        slot="activator"
        @click.stop=""
        style="max-width: 290px"
        class="textbox-dropdown-activator"
      ></div>
      <div
        v-if="isTimeType"
        tabindex="1"
        ref="datePickerContainer"
        @focus="onPickerContainerFocus"
        @blur="onPickerContainerBlur"
        style="background: white"
      >
        <!-- <v-time-picker
          :value="textInputValue"
          full-width
          @input="onTimeChange"
        ></v-time-picker> -->
        <TimePicker :value="value" @changed="onTimeChange" />
      </div>
      <div
        v-if="isDateType"
        tabindex="1"
        ref="datePickerContainer"
        @focus="onPickerContainerFocus"
        @blur="onPickerContainerBlur"
        class="date-picker-container"
        style="background: white"
        @click="onPickerClick"
      >
        <v-date-picker
          :value="textInputValue"
          @input="onDateChange"
        ></v-date-picker>
        <button
          v-if="canReset"
          class="dt-button s3"
          style="margin: 4px auto"
          @click="onClearDateClick"
        >
          Clear Date
        </button>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { complement, either, isNil, equals } from "ramda";
import { createValidator, validate, stringRequired, EventHooks } from "./index";
import { uuidv4 } from "../../utility";
import { TextFieldMixin } from "./text-field.mixin";
import TimePicker from "../time-picker/time-picker.vue";

export default {
  components: {
    TimePicker,
  },
  mixins: [TextFieldMixin()],
};

const isValidValue = complement(either(isNil, equals("")));
</script>

<style lang="scss" scoped>
.dt-input-box--container {
  --tf-margin: 5px;
  --background-color: inherit;
  --tf-margin-inner-left: 10px;
  --tf-hover-border-color: var(--sprt-75);
  --tf-webkit-box-shadow: 0 0 0 30px #212121 inset;
  --tf-webkit-text-fill-color: var(--sprt-2);

  margin: var(--tf-margin) !important;
  background-color: var(--background-color);

  &.m1 {
    --tf-margin: 6px 0px;
  }
  &.m0 {
    --tf-margin: 0px;
  }
  &.mb10 {
    --tf-margin: 0px 0px 10px 0px;
    // margin-bottom: 10px;
  }

  &.readonly {
    padding-bottom: 10px;
    border-bottom: 2px solid var(--sprt-95);

    &.outlined {
      border-bottom: 2px solid var(--sprt-4);
    }
  }

  .dt-input-box {
    position: relative;

    cursor: text;

    display: flex;
    justify-content: space-between;

    &.box {
      border-radius: 5px;
      color: var(--sprt-2);
      border: 1px solid var(--sprt-5);
    }

    &.readonly {
      --tf-margin: 0px;
      --tf-margin-inner-left: 0px;
      --tf-hover-border-color: transparent;
      margin-left: 0px;

      .input-container {
        width: 100%;
        display: flex;
        input {
          flex: 1;
        }
        .input--options {
          margin-left: 10px;
          .input--change {
            color: var(--bc-accent6);
          }
        }
      }
    }

    &.invalid {
      border: 1px solid var(--text-accent);
    }

    &.disabled:not(.readonly) {
      /** Opacity Should not be applied to the disabled style

      .dt-input-box--label {
        opacity: 0.4;
      }
      opacity: 0.8;

       */

      // Background Color Changing to XD Distribution Orders Design Template
      // Link: https://xd.adobe.com/view/3d3c9084-ade4-4ec6-877c-c054dc74c459-686f/specs/

      // Previous Background Color
      // background-color: var(--sprt-9);

      // New Background Color
      --background-color: var(--bc-3) !important;
      background-color: var(--background-color);
      border: 1px solid var(--background-color);

      // Change Color of Disabled Input
      input[disabled] {
        color: var(--text-5);
      }
    }

    .dt-input-box--label {
      // So that the label doesn't overflow the parent and causes a horizontal Scroller to appear
      max-width: 96%;

      display: flex;
      flex-direction: column;
      margin-top: 5px;
      // margin-left: var(--tf-margin-inner-left);
      margin-left: calc(var(--tf-margin-inner-left) + 1px);
      margin-bottom: 5px;

      transition: 150ms ease-out;

      &.label {
        font-size: 11px;
        transform: translateY(-10px) translateX(-1px);

        color: var(--text-5);

        // line-height: 11px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &.input {
        justify-content: center;
      }
      &.textarea {
        margin-top: 15px;
        justify-content: flex-start;
      }
    }

    .dt-input-box--edit {
      display: flex;
      flex-direction: column;
      justify-content: center;

      font-size: 13px;
      padding: 10px;

      opacity: 0;
    }

    .search-label {
      z-index: 1;
      margin-bottom: auto;
      margin-top: auto;
      cursor: pointer;
      min-width: 30px;
      text-align: end;
    }

    &.textarea {
      .input-container {
        width: 97%;
        top: 25px;
      }
    }

    .input-container {
      position: absolute;
      bottom: 5px;
      width: calc(
        100% - 20px
      ); // 70%; It was 70% Before, Probably to give space to the Validatin Icons
      margin-left: var(--tf-margin-inner-left);

      input,
      textarea {
        color: var(--text-2);
        width: 100%;
        // margin-right: 225px;
        background: var(--bc-main);
        outline: none;
        // color: black;
      }
      textarea {
        resize: none;
      }

      // Chrome Autofill Background Color Fix
      /* Change the white to any color ;) */

      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
        -webkit-box-shadow: var(--tf-webkit-box-shadow) !important;
      }
      /*Change text in autofill textbox*/
      input:-webkit-autofill {
        -webkit-text-fill-color: var(--tf-webkit-text-fill-color) !important;
      }
    }

    &:hover {
      .dt-input-box--edit {
        opacity: 1;
      }
    }

    border: 1px solid transparent;

    &:hover {
      border: 1px solid var(--tf-hover-border-color);
      box-shadow: none;
    }

    &.outlined {
      border: 1px solid var(--tf-hover-border-color);
      box-shadow: none;
    }

    margin: -1px;
    margin-bottom: -2px;

    .validation-status {
      margin-right: -25px;
      // margin-top: 10px;
      height: 100%;

      &.status-inside {
        margin-right: 10px;
        // margin-top: 11px;
      }
    }
  }
}

.dropdown--list {
  max-height: 300px;
}
.date-picker-container {
  background: white;
  padding: 4px;
  .picker.picker--date.card {
    box-shadow: none !important;
  }
}
</style>